module.exports = __webpack_public_path__ + "img/stlukes.90cf201d.png";